// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkDeactivateUser: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 20 16" width={width} height={height}>
            <path
                fill="currentColor"
                d="M14 4a4 4 0 0 0-7.715-1.481l.831.656a3 3 0 1 1 4.357 3.44l.83.657A4 4 0 0 0 14.002 4m1.638 11H4.001a4.57 4.57 0 0 1 4.572-4.5h1.365l-1.265-1h-.1A5.57 5.57 0 0 0 3 15.072c0 .512.415.928.928.928h12.144a.92.92 0 0 0 .578-.203zM.81.106a.505.505 0 0 0-.703.085.5.5 0 0 0 .084.703l19 15a.501.501 0 0 0 .622-.785z"
            />
        </svg>
    );
};

export default React.memo(LinkDeactivateUser);
